export default __webpack_public_path__ + "static/media/frostblast.b8341299.png";